export function parseMessageFromError(obj: any) {
	if (!obj) {
		return;
	}

	if (Array.isArray(obj?.error?.errors)) {
		return obj?.error?.errors.reduce((acc, value) => {
			return `${acc}${value.message}\n`;
		}, '');
	}

	if (obj.error?.message) {
		return obj.error.message;
	}

	if (obj.error?.Message) {
		return obj.error.Message;
	}

	if (obj.message) {
		return obj.message;
	}

	if (obj.Message) {
		return obj.Message;
	}

	return String(obj);
}
